import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { KeyboardKey, TRANSLATION_LANGUAGES } from '@mote/helpers/constants'
import ClickAwayListener from 'react-click-away-listener'
import { mote_primary } from '@mote/config/defaults/colors'
import { useKeyPress } from '@mote/helpers'

export const EditorTranslationLanguagesList = ({
  onLanguageSelection,
  onClose
}) => {
  useKeyPress(KeyboardKey.Escape, onClose)
  const Comparator = (a, b) => {
    if (a[1] < b[1]) return -1
    if (a[1] > b[1]) return 1
    return 0
  }

  const renderLanguages = () => {
    return TRANSLATION_LANGUAGES.sort(Comparator).map(language => {
      const languageCode = language[0]
      const name = language[1]

      return (
        <ListItem
          key={languageCode}
          value={languageCode}
          onClick={() =>
            onLanguageSelection && onLanguageSelection(languageCode)
          }
        >
          {name}
        </ListItem>
      )
    })
  }

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Root>
        <Backdrop onClick={onClose} />
        <Content>
          <ContentHeader>
            <Title>Translate into</Title>
          </ContentHeader>

          <LangListContainer>{renderLanguages()}</LangListContainer>
        </Content>
      </Root>
    </ClickAwayListener>
  )
}

const Root = styled.div`
  display: flex;
  position: relative;
  font-size: 0.875rem;
  line-height: 1.25rem;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: #ffffff;
  opacity: 0.75;
`
const Content = styled.div`
  display: flex;
  position: absolute;
  z-index: 20;
  background-color: #ffffff;
  flex-direction: column;
  width: 7rem;
  height: 10rem;
  border-radius: 0.375rem;
  border-width: 1px;
  border-color: #e5e7eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  top: -10px;
  right: 16px;
`

const ContentHeader = styled.div`
  width: 100%;
  border-bottom: 2px solid rgba(229, 231, 235);
`

const Title = styled.span`
  padding: 4px;
  margin-left: 4px;
  font-weight: 700;
`

const ListItem = styled.div`
  padding-left: 0.5rem;
  cursor: pointer;

  &:hover {
    color: ${mote_primary};
  }
`

const LangListContainer = styled.div`
  overflow: scroll;
  height: 16rem;
`

EditorTranslationLanguagesList.propTypes = {
  onLanguageSelection: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}
